<template>
  <div id="app">
    <!-- <Button type="primary" class="chat-btn" @click="showChat" icon="ios-chatboxes">沟通</Button> -->
    <Modal
      ref="modal"
      :zIndex="5000"
      @on-visible-change="visibleChange"
      v-model="modalVisible"
      :width="showModal ? '1024px' : 0"
      :footer-hide="true"
      class-name="chat-modal"
      :draggable="true"
      :closable="showModal"
      v-if="sdkAppID"
      :title="showModal ? '消息' : ''"
    >
      <TUIKit :SDKAppID="sdkAppID" :userID="userID" :userSig="userSig" />
      <TUICallKit class="callkit-container" :allowedMinimized="true" :allowedFullScreen="false" />
    </Modal>
  </div>
</template>
<script>
import { TUIKit } from '../../../TUIKit';
import { TUICallKit } from '@tencentcloud/call-uikit-vue2';
import axios from '@/libs/api.request';
import { mapState } from 'vuex';
import { TUIUserService, TUIStore, StoreName, TUIConversationService } from '@tencentcloud/chat-uikit-engine';
export default {
  name: '',
  components: {
    TUIKit,
    TUICallKit
  },
  computed: {
    ...mapState({
      userId: state => state.user.userId
    })
  },
  watch: {
    userId: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val || this.sdkAppID) {
          return;
        }
        axios
          .request({
            url: 'front/v1/im/user-sig',
            method: 'post'
          })
          .then(res => {
            this.sdkAppID = res.data.appId;
            this.userID = res.data.userID;
            this.userSig = res.data.userSig;
            this.$store.commit('setImUserId', this.userID);
            setTimeout(() => {
              TUIUserService.updateMyProfile({
                nick: res.data.nick,
                avatar: res.data.avatar
              });
            }, 3000);

            TUIStore.watch(StoreName.CONV, {
              totalUnreadCount: count => {
                this.$store.commit('setTotalUnreadCount', count);
              },
              currentConversationID: data => {
                if (data) {
                  this.$store.dispatch('getJobInfo', data);
                }
              }
            });
            this.$store.commit('setTimPrefix', res.data.prefix);
          });
      }
    }
  },
  data() {
    return {
      modalVisible: true,
      showModal: false,
      sdkAppID: '',
      userID: '',
      userSig: ''
    };
  },
  mounted() {
    this.$eventBus.$on('openChat', () => {
      this.showChat();
    });
    this.$eventBus.$on('closeChat', () => {
      this.showModal = false;
    });
  },
  methods: {
    showChat() {
      this.showModal = true;
    },
    visibleChange(show) {
      if (!show) {
        this.modalVisible = true;
        this.showModal = false;
        TUIConversationService.switchConversation();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.chat-btn {
  position: fixed;
  right: 30px;
  bottom: 30px;
}
::v-deep .chat-modal .ivu-modal-body {
  padding: 0;
}
::v-deep .ivu-modal-header {
  border: none;
}
</style>
